import React from 'react'; 
import './FeaturedCars.css';

import { Car, Heading } from '../../../components';
import { cars } from '../../../constants';
import { getPopular } from '../../../utils';

// import Swiper core and required modules 
import { Pagination, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
 
// Import Swiper styles  
import 'swiper/css';



const FeaturedCars = () => {

  const popular = getPopular(cars); // Get the Popular Cars from the cars array
  const popularCars = popular.slice(0, 6); // Selecting only the top 6 popular cars


  return (

    <section className='featuredCars'>

      {/* Section heading */}
      <Heading title={'Featured Cars'} subTitle={'Our Rental Fleet'} linear />

      <div className='featuredCar-slider'>
        <Swiper 
          // install Swiper modules
          modules={[Pagination, Autoplay]} // Enable Pagination & Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Enable infinite loop
          autoplay={{ delay: 3500, disableOnInteraction: false }} // Auto-play settings
          pagination={{ clickable: true }} // Enable pagination dots

          breakpoints= {{
            0:{ 
              slidesPerView: 1, // Show 1 slide on small screens
            },
            768:{
              slidesPerView: 2, // Show 2 slides on tablets
            },
            991:{
              slidesPerView: 2, // Show 3 slides on medium screens
            },
            1100:{
              slidesPerView: 3, // Show 3 slides on large screens
            }
          }}
        >
          {// Mapping through the popularCars array to create slides
            popularCars.map((car, index) => { 
              return (
                <SwiperSlide key={index}> 

                  <Car car={car} /> {/* Rendering Car component */}

                </SwiperSlide>
              )
            })
          }

        </Swiper>
      </div>

    </section>
  )
}

export default FeaturedCars;